import React from 'react'

const PublicFollowings = () => {
  return (
    <div>PublicFollowings</div>
  )
}

export default PublicFollowings